"use client";
import React, { useState } from "react";
import { MdAccountCircle } from "react-icons/md";
import { useGetUserDetailsQuery } from "./Myaccountapislice";
import MyAccountSetting from "./MyAccountSetting";
import MyAccountPerformance from "./MyAccountPerformance";
import MyAccountContent from "./MyAccountContent";
import { format } from "date-fns"; // Import the format function from date-fns
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";

export default function MyAccount() {
  const { data: userDetails, error, isLoading } = useGetUserDetailsQuery();
  const [activeTab, setActiveTab] = useState("setting");

  // console.log(userDetails);
  // Handle loading and error states
  if (isLoading) return <LoadingIndicator />;
  if (error) return <div>Error loading user details.</div>;
  // {
  //   roles: { Creator: 'Creator', Admin: 'Admin' },
  //   _id: '67655449333c61290d1d4d60',
  //   username: 'parag',
  //   email: 'paragagarwal675@gmail.com',
  //   password: '$2b$10$83vDL9Ec5xl8iiRyySz4cOYpNF0YC0GXLupxJiFi9o1dj7oGDkXp6',
  //   Group: [],
  //   defaultHomePage: true,
  //   Active: true,
  //   joining_date: null,
  //   Gender: 'Male',
  //   Dob: '2001-01-01T18:30:00.000Z',
  //   Phone: 9350251847,
  //   Region: 'North',
  //   Zone: 'India',
  //   userCompanylogo: '',
  //   name: 'Parag',}
  // Destructure user details from API response
  const { username, email, roles, firstLoginDate } = userDetails;
  // console.log(roles);

  // Format firstLoginDate using date-fns
  const formattedLoginDate = format(
    new Date(firstLoginDate),
    "MMMM/dd/yyyy, hh:mm a"
  );

  return (
    <section className="h-[94vh] flex flex-col items-start justify-center gap-[2px] py-[2px]">
      <div className="flex items-center justify-start gap-4 w-full border rounded h-[10%]">
        <MdAccountCircle className="text-7xl" />
        <div className="flex flex-col lg:gap-3 md:gap-0">
          <p className="tracking-wide">
            <strong className="">Username:</strong> {username}
          </p>

          <div className="flex items-center justify-start gap-4">
            <p className="tracking-wide">
              <strong className="">Email:</strong> {email}
            </p>
            <p className="tracking-wide">
              <strong className="">Site Role:</strong>{" "}
              {Object.keys(roles)
                .filter((key) => roles[key]) // Ensure only truthy roles are included
                .join(", ")}
            </p>

            <p className="tracking-wide">
              <strong className="">Last Sign In:</strong> {formattedLoginDate}
            </p>
          </div>
        </div>
      </div>
      <MyAccountSetting userDetails={userDetails} />
    </section>
  );
}
